import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  KompisSheetHeader,
  KompisSheetBody,
  KompisSheetFooter,
  KompisSheetFooterButtons
} from '@inter-ikea-kompis/react-components';
import { filtersReset, getSelectedGroupId } from 'ducks/products';
import { isMobileFiltersSheetVisible, showMobileFiltersSheet } from 'ducks/mobile';
import Filters from 'components/ProductSidebar/menus/Filters';
import Sheet from 'ui/Sheet/Sheet';
import { useAppDispatch } from 'ducks/hooks';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import SortingList from 'components/ProductSidebar/menus/Sorting';
import Title, { HeadingType } from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Box from 'ui/Box';
import { usePlannerConfig } from 'contexts/plannerConfig';
import { withWidgetContext } from 'contexts/widget';

const MobileFiltersSheet = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const {
    plannerConfig: { productGroups }
  } = usePlannerConfig();

  const mobileFiltersVisible = useSelector(isMobileFiltersSheetVisible);
  const selectedGroupId = useSelector(getSelectedGroupId);
  const selectedGroup = productGroups.find(({ id }) => id === selectedGroupId);
  const anySorting = !!selectedGroup?.mainMenu.sorting?.length;

  const onClose = () => {
    dispatch(showMobileFiltersSheet(false));
  };

  const resetFilters = () => {
    dispatch(filtersReset(selectedGroupId));
  };

  /* Kinda smelly, but this sheet has no config context */
  const SortingListWithContext = withWidgetContext(SortingList, {
    groupId: selectedGroupId,
    menuType: 'sheet'
  });

  return (
    <Sheet onOverlayClick={onClose} visible={mobileFiltersVisible}>
      <KompisSheetHeader
        theme={SkapaTheme}
        onCloseButtonClick={onClose}
        heading={formatMessage({ id: 'storageone.filterButtonNewMenu' })}
      />
      <KompisSheetBody theme={SkapaTheme}>
        {anySorting && (
          <>
            <Box px="l" py="s">
              <Title
                type={ThemeFontStyleTypeEnum.headingXSmall}
                fontWeight="bold"
                heading={HeadingType.HeadingThree}
              >
                {formatMessage({ id: 'storageone.sortingLabel' })}
              </Title>
            </Box>
            <SortingListWithContext />
          </>
        )}
        <Filters m="s" isFilterVisible={true} />
      </KompisSheetBody>
      <KompisSheetFooter theme={SkapaTheme}>
        <KompisSheetFooterButtons
          theme={SkapaTheme}
          primaryLabel={formatMessage({ id: 'storageone.mobileFilterButton' }, { products: '' })}
          secondaryLabel={formatMessage({ id: 'storageone.filterResetOptions' })}
          compact={false}
          onButtonClick={(event: any) =>
            event.detail.type === 'primaryButton' ? onClose() : resetFilters()
          }
        />
      </KompisSheetFooter>
    </Sheet>
  );
};

export default MobileFiltersSheet;
